import { CANDIDATE_PORTAL_BASE_URL } from 'src/config';

export function hasCandidatePortalUrl(text: string): boolean {
  if (!text || text.length === 0) {
    return false;
  }

  return text.includes(CANDIDATE_PORTAL_BASE_URL.url);
}
